// extracted by css-extract-rspack-plugin
var _1 = "TSNPD";
var _2 = "WIYG1";
var _3 = "PGUv1";
var _4 = "Idtcl";
var _5 = "Mt2TB";
var _6 = "vnJf_";
var _7 = "y8d9P";
var _8 = "UmQph";
var _9 = "e0wpX";
var _a = "BptzE";
var _b = "Vico0";
export { _1 as "compact", _2 as "full", _3 as "listViewBadge", _4 as "medium", _5 as "plainBadge", _6 as "totalCount", _7 as "totalCountBadge", _8 as "totalCount_Win32Style", _9 as "unreadCount", _a as "unreadOrTotalCount", _b as "unreadOrTotalCountOrUnreadCount_Win32Style" }
